import { ChairsOrientation } from '../types/index.js';

const TAU = Math.PI * 2;

export function angleForChairsOrientation(orientation: ChairsOrientation): number {
  switch (orientation) {
    case ChairsOrientation.North:
      return 0;
    case ChairsOrientation.East:
      return TAU * 0.25;
    case ChairsOrientation.South:
      return TAU * 0.5;
    case ChairsOrientation.West:
      return TAU * 0.75;
    default:
      return 0;
  }
}
